// src/hooks/useAuth.js
import { useState, useEffect } from 'react';

export default function useAuth() {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        // SWA provides this special endpoint to get user details
        const response = await fetch('/.auth/me');
        if (response.ok) {
          const data = await response.json();
          // The user details are in the clientPrincipal object.
          // If it's null, the user is not logged in.
          setUser(data.clientPrincipal);
        } else {
          // A non-OK response likely means the user is not logged in
          setUser(null);
        }
      } catch (e) {
        console.error("Failed to fetch user auth data:", e);
        setUser(null); // Assume not logged in on error
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserData();
  }, []);

  return { user, isLoading };
}